import React from 'react';
import styles from './OptOutFooter.module.css';

export const OptOutFooter = () => (
  <div className={styles.container}>
    <p className={styles.title}>
      Opt-Out of Personal Information Sale and Targeted Advertising
    </p>
    <p className={styles.body}>
      Certain U.S. state privacy laws, including the California Consumer Privacy
      Act (CCPA/CPRA), Colorado Privacy Act (CPA), Virginia Consumer Data
      Protection Act (VCDPA), Connecticut Data Privacy Act (CTDPA), and other
      applicable state laws, grant residents the right to opt out of the sale or
      sharing of their personal information and targeted advertising.
    </p>
    <p className={styles.body}>
      Residents of the following states may exercise their opt-out rights under
      applicable law:
    </p>
    <p className={styles.body}>
      California (CA), Colorado (CO), Connecticut (CT), Virginia (VA), Utah
      (UT), Texas (TX), Oregon (OR), Montana (MT), Nebraska (NE), Iowa (IA),
      Indiana (IN), Kentucky (KY), Tennessee (TN), Maryland (MD), District of
      Columbia (DC), Delaware (DE), New Jersey (NJ), Rhode Island (RI), and New
      Hampshire (NH).
    </p>
  </div>
);
